import Combine from '../../components/Combine/Combine'
import LoginForm from './LoginForm';

const Login = () => {
  return (
    <Combine>
      <h2 className='text-3xl  p-7'>Student Profile</h2>
      <LoginForm/>
    </Combine>
  );
}

export default Login
